import { useCallback, useState } from "react";
import { Container } from "../common/HtmlTags/Container/Container";
import Header from "../common/Header/Header";
import { Outlet } from "react-router-dom";
import SuspendedAccount from "../feature/SuspendedAccount/SuspendedAccount";
import useCommonData from "../../hooks/useCommon";
import Footer from "../common/Footer/Footer";
import { PageLoader } from "../common/Loaders/PageLoader";
import "./DashboardLayout.css";
import { useDeepLinkNavigation } from "../../hooks/useDeepLinkNavigation";
import { useForegroundPushNavigation } from "../../hooks/useForegroundPushNavigation";
import OnboardingGate from "../feature/OnboardingGate/OnboardingGate";
import { useCompleteAuthenticatedSession } from "../../hooks/useCompleteAuthenticatedSession";
import {
  clearPendingOnboardingUserId,
  getPendingOnboardingUserId,
} from "../../utils/pendingOnboarding";
import { useAppSelector } from "../../hooks/redux";
import { authSelector } from "../../store/slices/authSlice";

const DashboardLayout = () => {
  const authState = useAppSelector(authSelector) as { token?: string | null };
  const hasToken = Boolean(authState?.token);
  const { userProfile, isBlockedByAdmin } = useCommonData();
  const showLoader = hasToken && !userProfile;
  const deepLinkEnabled = Boolean(userProfile) && !isBlockedByAdmin;
  const { continueSessionAfterOnboarding } = useCompleteAuthenticatedSession();
  const [onboardingUserId, setOnboardingUserId] = useState<string | null>(() =>
    hasToken ? getPendingOnboardingUserId() : null
  );

  useDeepLinkNavigation(deepLinkEnabled);
  useForegroundPushNavigation(deepLinkEnabled);

  const handleOnboardingSuccess = useCallback(async () => {
    if (!onboardingUserId) {
      return;
    }
    const userId = onboardingUserId;
    clearPendingOnboardingUserId();
    setOnboardingUserId(null);
    await continueSessionAfterOnboarding(userId);
  }, [onboardingUserId, continueSessionAfterOnboarding]);

  const content = (
    <Container className="dashboard-layout-wrapper">
      <Header />
      <Container className="dashboard-layout-content-wrapper">
        {showLoader ? (
          <PageLoader />
        ) : (
          <Container className="dashboard-content-section-wrapper">
            {hasToken && isBlockedByAdmin ? <SuspendedAccount /> : <Outlet />}
          </Container>
        )}
      </Container>
      <Footer />
    </Container>
  );

  if (!hasToken) {
    return content;
  }

  return (
    <OnboardingGate userId={onboardingUserId} onSuccess={handleOnboardingSuccess}>
      {content}
    </OnboardingGate>
  );
};
export default DashboardLayout;
